import React from 'react'

function WebOrgan() {
    return (
        <>
            <img src="./img/home/intro3.png" alt="" style={{ width: '100%', height: 'auto', display: 'block' }} />
        </>
    )
}

export default WebOrgan
